/**
 * Lightweight cyber ambient layer: mesh orbs + grid + noise.
 * No Three.js — CSS only, asset-canister friendly.
 */
export function AmbientField() {
	return (
		<div className="ambient-field" aria-hidden>
			<div className="ambient-field__mesh" />
			<div className="ambient-field__grid" />
			<div className="ambient-field__noise" />
		</div>
	);
}
